export const sliderItems = [
    {
        id: 1,
        img: "https://www.pikpng.com/pngl/b/127-1274139_about-us-black-lady-holding-shopping-bag-png.png",
        title: "SUMMER SALE",
        desc: "DONT COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "f5fafd",
    },
    {
        id: 2,
        img: "https://www.pikpng.com/pngl/b/127-1274139_about-us-black-lady-holding-shopping-bag-png.png",
        title: "WINTER SALE",
        desc: "DONT COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fcf1ed",
    },
    {
        id: 3,
        img: "https://www.pikpng.com/pngl/b/127-1274139_about-us-black-lady-holding-shopping-bag-png.png",
        title: "POPULAR SALE",
        desc: "DONT COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fbf0f4",
    }
]

export const categories = [
    {
        id: 1,
        img: "https://media.gq-magazine.co.uk/photos/5e11c5c8b09b8500083cd686/master/pass/MFW20london-8508973.jpg",
        title: "SHIRT STYLE!",
    },
    {
        id: 2,
        img: "https://i.pinimg.com/originals/7e/68/53/7e6853beac65ec6af03ba217b0f32cec.jpg",
        title: "LOUNGEWEAR LOVE",
    },
    {
        id: 3,
        img: "https://static.onecms.io/wp-content/uploads/sites/14/2020/07/15/fashion-header-1-2000.jpg",
        title: "LIGHT JACKETS",
    }
]


export const popularProducts = [
    {
        id: 1,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 2,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 3,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 4,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 5,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 6,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 7,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 8,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 7,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    },
    {
        id: 8,
        img: "https://www.ubuy.vn/productimg/?image=aHR0cHM6Ly9tLm1lZGlhLWFtYXpvbi5jb20vaW1hZ2VzL0kvNDFVbmtmbFNHTkwuX0FDX1NSNDAwLDQwMF8uanBn.jpg"
    }
]